import { render, staticRenderFns } from "./editHoliday.vue?vue&type=template&id=1bd753a0&scoped=true&"
import script from "./editHoliday.vue?vue&type=script&lang=js&"
export * from "./editHoliday.vue?vue&type=script&lang=js&"
import style0 from "./editHoliday.vue?vue&type=style&index=0&id=1bd753a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd753a0",
  null
  
)

export default component.exports